import { Browser } from "../../core/browser";
import { AuxiliumComponent } from "../auxilium-component";

export class SidebarItem extends AuxiliumComponent {
	static observedAttributes = ["active"];

	constructor() {
		super();

		this.link = this.getAttribute("link") ?? "";
		this.icon = this.getAttribute("icon") ?? "";
		this.active = this.hasAttribute("active");
		this.accordion = null;
	}

	get collapsed() {
		return this.closest("chip-framesidebar")?.collapsed;
	}

	parsedCallback() {
		const children = this.querySelectorAll(":scope > chip-sidebaritem, :scope > chip-sidebarheader");

		if (this.link) {
			this.appendChild(document.createElementWithContents("chip-button", this.childNodes, {
				link: this.link,
				variation: "sidebar",
				icon: this.icon,
				active: this.active,
				tooltipPlacement: "right",
				tooltip: this.collapsed ? ([...this.childNodes ?? []].at(0)?.textContent ?? "") : ""
			}));
		}

		if (children.length) {
			this.accordion = document.createElementWithContents("chip-accordionitem", children, { className: "sidebar-item--accordion" });

			this.appendChild(document.createElementWithContents("chip-button", null, {
				icon: "fas fa-chevron-down",
				buttonStyle: "icon",
				variation: "body",
				description: "Toggle more options",
				className: "sidebar-item--accordion-toggle",
				onclick: () => this.Toggle()
			}));

			this.insertAdjacentElement("afterend", document.createElementWithContents("chip-sidebaritem", this.accordion));
		}
	}

	Toggle() {
		this.accordion?.Toggle();

		this.querySelector(".sidebar-item--accordion-toggle")?.toggleClass("open", this.accordion?.open);
	}

	Open() {
		if (this.closest("chip-framesidebar")?.collapsed) { return; }

		this.accordion?.Open();

		this.querySelector(".sidebar-item--accordion-toggle")?.classList.add("open");

		const currentItem = this.closest("chip-accordionitem");

		if (currentItem?.parentElement?.previousElementSibling) {
			currentItem.parentElement.previousElementSibling.Open();
		}
	}

	Close() {
		this.accordion?.Close();

		this.querySelector(".sidebar-item--accordion-toggle")?.classList.remove("open");
	}

	attributeChanged(name, _, newValue) {
		if (name === "active") {
			const button = this.querySelector("chip-button[variation='sidebar']");

			if (button) {
				button.active = this.IsAttributeValueTrue(newValue);
			}
		}
	}
}